import { useState, useEffect } from "react";
import { FiAlertCircle } from "react-icons/fi";
import { IoIosArrowForward } from "react-icons/io";
import { useLocation, useNavigate, useParams, Link } from "react-router-dom";
import ProfessionalInfo from "../components/professionals/professionaldetail/ProfessionalInfo";
import RelatedCollaborators from "../components/professionals/professionaldetail/RelatedCollaborators";
import RelatedProjectsProf from "../components/professionals/professionaldetail/RelatedProjectsProf";
import LikeComponent from "../components/suspense/LikeComponent";
import ScamAlertRequestModal from "../components/suspense/ScamAlertRequestModal";
import ProfessionalExperience from "./../components/professionals/professionaldetail/ProfessionalExperience";
import { getProfessionalById } from "../service/MainService";

const ProfessionalDetailPage = () => {
  const location = useLocation();
  const { UserId } = useParams();
  const [userDetails, setUserDetails] = useState(location.state?.userDetails || null);
  const [loading, setLoading] = useState(!userDetails);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userDetails && UserId) {
      const fetchDetails = async () => {
        try {
          const token = localStorage.getItem("accessToken");
          const data = await getProfessionalById(UserId, token);
          setUserDetails(data);
        } catch (error) {
          console.error("Error fetching professional details:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchDetails();
    }
  }, [UserId, userDetails]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-500">Loading profile...</p>
      </div>
    );
  }

  if (!userDetails) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-red-500">Professional profile not found.</p>
      </div>
    );
  }

  const handleClick = () => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setOpen(true);
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <div className="transform duration-200 easy-in-out relative">
        <div className=" h-52 overflow-hidden bg-gray-300">
          <nav
            className="flex justify-center text-gray-900 font-semibold uppercase pt-20"
            aria-label="Breadcrumb"
          >
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
              <li aria-current="page">
                <div className="flex items-center">
                  <Link
                    to="/"
                    className="ms-1 text-md  md:ms-2 dark:text-gray-400"
                  >
                    Home
                  </Link>
                </div>
              </li>
              <li aria-current="page">
                <div className="flex items-center">
                  <IoIosArrowForward />
                  <Link
                    to="/professionals"
                    className="ms-1 text-md md:ms-2 dark:text-gray-400"
                  >
                    Professionals
                  </Link>
                </div>
              </li>
              <li aria-current="page">
                <div className="flex items-center">
                  <IoIosArrowForward />
                  <Link className="ms-1 text-md md:ms-2 dark:text-gray-400">
                    {userDetails.Name}
                  </Link>
                </div>
              </li>
            </ol>
          </nav>
        </div>
        <div className="flex justify-center px-5 -mt-12">
          <img
            className="h-44 w-44 bg-white p-2 rounded-full"
            src={userDetails.ProfilePicture}
            alt=""
          />
        </div>
        <div className="px-14 py-10">
          <div className="flex items-center justify-center">
            <div className="text-2xl border-r border-gray-400 pr-4">
              {userDetails.Name}
            </div>
            <div className="flex items-center gap-4 text-gray-500 text-lg cursor-pointer font-semibold pl-4">
              <LikeComponent userDetails={userDetails} />
              <FiAlertCircle className="cursor-pointer" onClick={handleClick} />
            </div>
          </div>
        </div>
        <div className="lg:px-40 flex flex-col gap-6 px-5 text-center justify-center">
          <span>{userDetails.ShortBio}</span>
        </div>
        <ProfessionalInfo userDetails={userDetails} />
        {userDetails.Occupation !== "Company" && (
          <ProfessionalExperience userDetails={userDetails} />
        )}
        <RelatedProjectsProf userDetails={userDetails} />
        <RelatedCollaborators userId={userDetails.UserId} />
      </div>
      <ScamAlertRequestModal
        open={open}
        setOpen={setOpen}
        userDetails={userDetails}
      />
    </>
  );
};

export default ProfessionalDetailPage;
